import { ReferenzaFirestore } from '../models/firestore/referenza.model';

/**
 * Normalizza i dati della referenza convertendo i campi numerici in stringhe.
 * Gestisce la transizione da number a string per codiceCommerciale e codiceCertificato.
 */
export function normalizeReferenzaData(ref: ReferenzaFirestore): ReferenzaFirestore {
  return {
    ...ref,
    codiceCommerciale: normalizeToString(ref.codiceCommerciale),
    codiceCertificato: normalizeToString(ref.codiceCertificato)
  };
}

/**
 * Converte un valore number o string in string.
 * Se il valore è null o undefined, ritorna null.
 */
function normalizeToString(value: number | string | null | undefined): string | null {
  if (value === null || value === undefined) {
    return null;
  }
  // Se è già una stringa, ritorna così com'è
  if (typeof value === 'string') {
    return value;
  }
  // Se è un numero, convertilo in stringa
  return String(value);
}

/**
 * Prepara i dati della referenza per il salvataggio su Firestore.
 * Assicura che codiceCommerciale e codiceCertificato siano sempre stringhe.
 */
export function prepareReferenzaForSave(data: Partial<ReferenzaFirestore>): Partial<ReferenzaFirestore> {
  const prepared = { ...data };
  
  if ('codiceCommerciale' in prepared) {
    prepared.codiceCommerciale = normalizeToString(prepared.codiceCommerciale);
  }
  
  if ('codiceCertificato' in prepared) {
    prepared.codiceCertificato = normalizeToString(prepared.codiceCertificato);
  }
  
  return prepared;
}
